/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertMinimalNaturalPersonCommandDto
 */
export interface UpsertMinimalNaturalPersonCommandDto {
    /**
     * ID of the person to update. If null or not provided, a new person will be created.
     * @type {string}
     * @memberof UpsertMinimalNaturalPersonCommandDto
     */
    id?: string | null;
    /**
     * Last name of the person
     * @type {string}
     * @memberof UpsertMinimalNaturalPersonCommandDto
     */
    lastName: string;
    /**
     * First name of the person
     * @type {string}
     * @memberof UpsertMinimalNaturalPersonCommandDto
     */
    firstName: string;
    /**
     * Email address of the person
     * @type {string}
     * @memberof UpsertMinimalNaturalPersonCommandDto
     */
    email: string;
    /**
     * Date of birth of the person (must be at least 16 years old)
     * @type {Date}
     * @memberof UpsertMinimalNaturalPersonCommandDto
     */
    birthDate: Date;
}

/**
 * Check if a given object implements the UpsertMinimalNaturalPersonCommandDto interface.
 */
export function instanceOfUpsertMinimalNaturalPersonCommandDto(value: object): value is UpsertMinimalNaturalPersonCommandDto {
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    return true;
}

export function UpsertMinimalNaturalPersonCommandDtoFromJSON(json: any): UpsertMinimalNaturalPersonCommandDto {
    return UpsertMinimalNaturalPersonCommandDtoFromJSONTyped(json, false);
}

export function UpsertMinimalNaturalPersonCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertMinimalNaturalPersonCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'lastName': json['lastName'],
        'firstName': json['firstName'],
        'email': json['email'],
        'birthDate': (new Date(json['birthDate'])),
    };
}

export function UpsertMinimalNaturalPersonCommandDtoToJSON(json: any): UpsertMinimalNaturalPersonCommandDto {
    return UpsertMinimalNaturalPersonCommandDtoToJSONTyped(json, false);
}

export function UpsertMinimalNaturalPersonCommandDtoToJSONTyped(value?: UpsertMinimalNaturalPersonCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'email': value['email'],
        'birthDate': ((value['birthDate']).toISOString()),
    };
}

